import { render, staticRenderFns } from "./ClientCabinFooter.vue?vue&type=template&id=2e7f759d&scoped=true&"
import script from "./ClientCabinFooter.vue?vue&type=script&lang=ts&"
export * from "./ClientCabinFooter.vue?vue&type=script&lang=ts&"
import style0 from "./ClientCabinFooter.vue?vue&type=style&index=0&id=2e7f759d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7f759d",
  null
  
)

export default component.exports